export default __webpack_public_path__ + "static/media/transiluminator-switch-off.427ddfcd.svg";